import moment from 'moment';
import { ILandsatLayerResult, ISentinelLayerResult } from './layers';

export interface IDateRangeObject {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}

export interface ITimelineUpdateDataObject {
  startDate?: moment.Moment | null;
  endDate?: moment.Moment | null;
  cloudCover?: number;
  visibility?: IVisibilityObject;
}

export interface IVisibilityObject {
  layers: Array<string>;
  visible: boolean;
}

export enum IImageryLayer {
  sentinel = 1,
  landsat = 2,
}
export interface ITimelineImageObject {
  acquisitionDate: number;
  imageLayer: IImageryLayer;
  oid: number;
  highlightID: string | number;
  locked: boolean;
  cloudcover: number;
}

export interface IHandleProps {
  value: number;
  dragging?: boolean;
  index: number;
}

export interface ITimelineProps {
  open: Boolean;
  landsatResults?: Array<ILandsatLayerResult>;
  sentinelResults?: Array<ISentinelLayerResult>;
}

export interface ITimelineDispatchProps {
  closeTimeline: () => void;
  _setTimelineDates: (dates: IDateRangeObject) => void;
}

export interface IHighlightedImageObject {
  id: string | number;
  layer: string;
}

export interface ITimelineState {
  maxDateRange: IDateRangeObject;
  dateRange: IDateRangeObject;
  focusedDateInput: string | null;
  cloudCover: number;
  visibleImageLayers: Array<string>;
  disabledInput: string;
  highlightedImage: IHighlightedImageObject | null;
  hasBeforeImage: boolean;
}

export interface IDayPickerRangeProps {
  dateRange: IDateRangeObject;
  maxDateRange: IDateRangeObject;
  updateDateRange: Function;
}

export interface IDrilldownDataObject {
  x: number;
  y: number | undefined;
  name: string;
  originalDate: number;
}

export interface IImagePair {
  [index: string]: ITimelineImageObject;
}